import { notesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes";
import { COLORS } from "@store/theme/common/design";
import { checkoutBlockSubTitleStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(notesStyles, {
    wrapper: {
        css: css`
            margin-top: 20px;
        `,
    },
    titleText: {
        variant: "h4",
        css: css`
            ${checkoutBlockSubTitleStyles()}
            margin-bottom: 5px;
        `,
    },
    notesText: {
        size: 15,
        color: COLORS.text.dark,
    },
});
